/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeAssistanceResolutionActor } from './EmployeeAssistanceResolutionActor';
import type { EmployeeAssistanceVisibility } from './EmployeeAssistanceVisibility';
import type { EmployeeExecutionAdvisory } from './EmployeeExecutionAdvisory';
/**
 * Advisory assistance resolved explicitly after review.
 */
export type ResolvedEmployeeAdvisoryAssistance = {
    /**
     * Stable identifier for this individual assistance incident.
     */
    assistanceId: string;
    /**
     * AI Agent associated with the latest assistance outcome.
     */
    employeeId: string;
    /**
     * AI Agent version used by the latest execution.
     */
    version: (number | 'DRAFT');
    /**
     * CRM conversation associated with the assistance, when available.
     */
    conversationId?: number;
    /**
     * CRM funnel containing the conversation, when available.
     */
    funnelId?: number;
    /**
     * Latest execution that changed this assistance record.
     */
    latestExecutionId: string;
    /**
     * Objective active when the assistance outcome occurred.
     */
    objective: string;
    /**
     * Audience allowed to see this assistance record.
     */
    visibility: EmployeeAssistanceVisibility;
    /**
     * Time when this assistance context first became open.
     */
    openedAt: string;
    /**
     * Time when the record last changed.
     */
    updatedAt: string;
    /**
     * Advisory impact discriminator.
     */
    impact: ResolvedEmployeeAdvisoryAssistance.impact;
    /**
     * Sanitized issue that merits review without blocking the execution.
     */
    advisory: EmployeeExecutionAdvisory;
    /**
     * Resolved lifecycle state.
     */
    status: ResolvedEmployeeAdvisoryAssistance.status;
    /**
     * Time when the advisory was resolved.
     */
    resolvedAt: string;
    /**
     * System or user that resolved the assistance, when recorded.
     */
    resolvedBy?: EmployeeAssistanceResolutionActor;
};
export namespace ResolvedEmployeeAdvisoryAssistance {
    /**
     * Advisory impact discriminator.
     */
    export enum impact {
        ADVISORY = 'advisory',
    }
    /**
     * Resolved lifecycle state.
     */
    export enum status {
        RESOLVED = 'resolved',
    }
}

